import { module } from 'modujs'
import { CUSTOM_EVENT, ENV, FONT } from '../config'
import { whenReady } from '../utils/fonts'
import { SplitText } from '../gsap'

export default class AnimText extends module {

    static get settings() {
        return {
            CLASSNAME: 'o-anim-text',
            VISIBLE_CLASS: 'is-inview',
            SPLIT_TYPES: {
                block: {
                    splitType: false,
                    class: '-block'
                },
                chars: {
                    splitType: 'lines, words, chars',
                    class: '-chars'
                },
                lines: {
                    splitType: 'lines, words',
                    class: '-lines'
                },
            },
        }
    }

    constructor(m) {
        super(m)

        this.$el = this.el
        this.$inner = this.$('inner')[0]

        // Define animation type
        let type = this.getData('type') || 'lines' // lines by default

        // Define inline/block element
        this.splitTag = this.getData('inline') !== undefined ? 'span' : 'div'

        // Remove glitchy characters animation on mobile
        if(ENV.IS_MOBILE && type == 'chars') {
            type = 'lines'
        }

        this.TYPE = AnimText.settings.SPLIT_TYPES[type]
    }

    init() {

        if(ENV.REDUCED_MOTION) {
            return
        }

        this.$el.classList.add(AnimText.settings.CLASSNAME)

        // Hidden text per default
        this.isActive = true

        // No split as default
        this.splitType = this.TYPE.splitType
        this.$el.classList.add(this.TYPE.class)

        whenReady(FONT.EAGER).then(() => {
            // Split lines
            this.initSplits()

            // Resize event
            window.addEventListener(CUSTOM_EVENT.RESIZE_END, this.onResize = () => this.resize())
        })
    }

    initSplits() {

        if(!this.splitType) {
            return
        }

        // Split text
        this.split = new SplitText(this.$inner, {
            tag: this.splitTag,
            type: this.splitType,
            linesClass: `${AnimText.settings.CLASSNAME}_line`,
            wordsClass: `${AnimText.settings.CLASSNAME}_word`,
            charsClass: `${AnimText.settings.CLASSNAME}_char`,
        })

        // Lines
        const lineCount = this.split.lines.length
        if(lineCount > 0) {
            this.$el.style.setProperty('--anim-text-line-count', lineCount)
            this.split.lines.forEach(($line, i) => $line.style.setProperty('--anim-text-line-index', i))
        }

        // Chars
        const charCount = this.split.chars.length
        if(charCount > 0) {
            this.$el.style.setProperty('--anim-text-char-count', charCount)
            this.split.chars.forEach(($char, i) => $char.style.setProperty('--anim-text-char-index', i))
        }
    }

    revertSplits() {
        if(!this.splitType) return

        this.split.revert()
    }

    resize() {

        if(!this.isActive) {
            return
        }

        if(this.splitType) {
            this.revertSplits()
            this.initSplits()
        }
    }

    endReveal() {
        this.isActive = false

        setTimeout(() => {
            this.revertSplits()

            window.removeEventListener(CUSTOM_EVENT.RESIZE_END, this.onResize)
        }, 2000)
    }

    destroy() {
        if(this.isActive) {
            window.removeEventListener(CUSTOM_EVENT.RESIZE_END, this.onResize)
        }
    }
}
